module.exports = __webpack_public_path__ + "media/gateway/cvv-tarjeta-2-bbb638f0.png";